import { render } from "./Slide.vue?vue&type=template&id=6cc5148b&scoped=true"
import script from "./Slide.vue?vue&type=script&lang=js"
export * from "./Slide.vue?vue&type=script&lang=js"

import "./Slide.vue?vue&type=style&index=0&id=6cc5148b&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cc5148b"]])

export default __exports__